import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import {TiFolderOpen} from 'react-icons/ti';
import {useThemeContext} from '../../../../../@crema/utility/AppContextProvider/ThemeContextProvider';

const UploadModern = ({uploadText, dropzone, isInvalid = false}) => {
  const {theme} = useThemeContext();
  return (
    <Box
      sx={{
        position: 'relative',
        '& ul': {
          listStyle: 'none',
          padding: 0,
        },
      }}
    >
      <Box
        {...dropzone.getRootProps({className: 'dropzone'})}
        sx={{
          cursor: 'pointer',
          border: (theme) =>
            `dashed 2px ${
              isInvalid
                ? theme?.palette?.error?.main || '#f44336'
                : theme?.palette?.divider || '#e0e0e0'
            }`,
          borderRadius: 2.5,
          p: 5,
          textAlign: 'center',
          mb: 4,
          color: isInvalid ? 'error.main' : 'text.secondary',
          backgroundColor: isInvalid ? 'error.light' : 'background.default',
        }}
      >
        <input {...dropzone.getInputProps()} />
        <TiFolderOpen
          style={{
            fontSize: 40,
            marginBottom: 4,
            color: isInvalid
              ? theme?.palette?.error?.main || '#f44336'
              : theme?.palette?.primary?.main || '#1976d2',
          }}
        />
        <p>{uploadText}</p>
      </Box>
    </Box>
  );
};

export default UploadModern;

UploadModern.propTypes = {
  uploadText: PropTypes.string,
  dropzone: PropTypes.object,
  isInvalid: PropTypes.bool,
};
